import { ref, watch } from 'vue';
import { defineStore } from 'pinia';

import Api from '@/api/Api';

import {
	collectGssOverlayStations,
} from '@/utils/mapGssOverlayUtils';
import type { GssWindowItem } from '@/utils/mapGssOverlayUtils';

import { useUserStore } from '@/stores/user';
import { useLicenseStore } from '@/stores/licenseStore';


type SpoofingGssWindowResponse = {
	items: GssWindowItem[];
};


export const useMapGssOverlayStore = defineStore('mapGssOverlayStore', () => {
	const failingGnssByMountpoint = ref<ReadonlyMap<string, readonly string[]>>(new Map());
	const isVisible = ref(false);
	const { apiData, doRequest } = Api.useSpoofingGssWindowGet();

	const updateFromItems = (items: readonly GssWindowItem[]): void => {
		failingGnssByMountpoint.value = collectGssOverlayStations(items).failingGnssByMountpoint;
	};

	watch(apiData, (response: SpoofingGssWindowResponse) => {
		if (response?.items != null) {
			updateFromItems(response.items);
		}
	});

	const refresh = (): void => {
		if (!isVisible.value || !useUserStore().allowToSeeModuleStatuses || !useLicenseStore().featureFlagJamming) {
			return;
		}
		doRequest({});
	};

	const setVisibility = (visibility: boolean): void => {
		isVisible.value = visibility;
		if (!visibility) {
			failingGnssByMountpoint.value = new Map();
		}
		refresh();
	};

	return {
		failingGnssByMountpoint,
		isVisible,
		setVisibility,
		refresh,
	};
});
